import React from 'react';
import PropTypes from 'prop-types';
import { Modal, Button, Form, Col, InputGroup } from 'react-bootstrap';
const uuid = require('uuid');

const Globals = require('../../../../app/globals');
const StringUtil = require('../../../../app/shared/StringUtil');
const ShortCourseActions = require('../../actions/ShortCourseActions');
const ShortCourseStore = require('../../stores/ShortCourseStore');
import WithShortCourseLicenseData from '../DataHOCs/WithShortCourseLicenseData';
import Strings from '../../../../app/shared/Strings';
import ErrorBox from '../common/ErrorBox';

const propTypes = {
    shortCourseId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
    shortCourseHash: PropTypes.string.isRequired,
    licenses: PropTypes.object.isRequired,
    onClose: PropTypes.func.isRequired,
};

const defaultProps = {};

const NEW_LICENSE_TOKEN = 'new';

class AddShortCourseLicenseModal extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            addActionId: null,
            updateActionId: null,
            deleteActionId: null,
            requestError: null,
            selectedLicenseToken: NEW_LICENSE_TOKEN,
            cost: 0,
            saleCost: 0,
            origToken: '',
            token: '',
            licenseTypeToken: Globals.ecommerce.course_license_types.INDIVIDUAL,
            joinCourseInstanceHash: '',
        };
        this.onAddLicense = this.onAddLicense.bind(this);
        this.onDeleteLicense = this.onDeleteLicense.bind(this);
        this.onSelectLicense = this.onSelectLicense.bind(this);
        this.unsubscribes = [ShortCourseStore.listen(this.onShortCourseStoreChange.bind(this))];
    }

    componentWillUnmount() {
        this.unsubscribes.forEach(u => u());
    }

    onAddLicense() {
        if (this.state.selectedLicenseToken === NEW_LICENSE_TOKEN) {
            const actionId = uuid.v4();
            this.setState({ addActionId: actionId }, () => {
                ShortCourseActions.addShortCourseLicense(actionId, {
                    shortCourseHash: this.props.shortCourseHash,
                    token: this.state.token,
                    cost: this.state.cost,
                    saleCost: this.state.saleCost,
                    licenseTypeToken: this.state.licenseTypeToken,
                    joinCourseInstanceHash: this.state.joinCourseInstanceHash,
                });
            });
        }
        else {
            const actionId = uuid.v4();
            this.setState({ updateActionId: actionId }, () => {
                ShortCourseActions.updateShortCourseLicense(actionId, {
                    token: this.state.origToken,
                    newToken: this.state.token,
                    cost: this.state.cost,
                    saleCost: this.state.saleCost,
                    joinCourseInstanceHash: this.state.joinCourseInstanceHash,
                });
            });
        }
    }

    onDeleteLicense() {
        if (window.confirm(Strings['en'].common.CONFIRM_DECISION)) {
            const actionId = uuid.v4();
            this.setState({ deleteActionId: actionId }, () => {
                ShortCourseActions.deleteShortCourseLicense(actionId, {
                    shortCourseHash: this.props.shortCourseHash,
                    token: this.state.origToken,
                });
            });
        }

    }

    onSelectLicense(token) {
        let updatedState = { selectedLicenseToken: token };
        if (token === NEW_LICENSE_TOKEN) {
            updatedState = {
                ...updatedState,
                origToken: '',
                token: '',
                cost: 0,
                saleCost: 0,
                licenseTypeToken: Globals.ecommerce.course_license_types.INDIVIDUAL,
                joinCourseInstanceHash: '',
            };
        }
        else {
            const license = this.props.licenses[token];
            updatedState = {
                ...updatedState,
                origToken: license.token,
                token: license.token,
                cost: license.cost,
                saleCost: license.sale_cost,
                licenseTypeToken: license.license_type_token,
                joinCourseInstanceHash: license.join_course_instance_hash,
            };
        }

        this.setState(updatedState);
    }

    onShortCourseStoreChange(newState) {
        if (this.state.addActionId === newState.action.id) {
            if (!newState.action.error) {
                this.setState({ requestError: null, addActionId: null }, () => {
                    this.props.onClose();
                });
            }
            else {
                this.setState({ requestError: newState.action.error, addActionId: null });
            }
        }
        else if (this.state.updateActionId === newState.action.id) {
            if (!newState.action.error) {
                this.setState({ requestError: null, updateActionId: null }, () => {
                    this.props.onClose();
                });
            }
            else {
                this.setState({ requestError: newState.action.error, updateActionId: null });
            }
        }
        else if (this.state.deleteActionId === newState.action.id) {
            if (!newState.action.error) {
                this.setState({ requestError: null, deleteActionId: null }, () => {
                    this.props.onClose();
                });
            }
            else {
                this.setState({ requestError: newState.action.error, deleteActionId: null });
            }
        }
    }

    render() {
        const licenseOptions = Object.values(this.props.licenses).map((license) => {
            return {
                token: license.token,
                title: license.token,
                selected: license.token === this.state.selectedLicenseToken
            };
        });

        licenseOptions.unshift({
            token: NEW_LICENSE_TOKEN,
            title: Strings['en'].short_course.modals.add_license.NEW_LICENSE_NAME,
            selected: NEW_LICENSE_TOKEN === this.state.selectedLicenseToken,
        });

        return (
            <Modal
                show
                enforceFocus={false}
                backdrop={false}
                animation={false}
                keyboard
                onHide={this.props.onClose}
            >
                <Modal.Header closeButton onHide={this.props.onClose}>
                    <Modal.Title>{Strings['en'].short_course.modals.add_license.MODAL_HEADER}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <ErrorBox error={this.state.requestError} />
                    <Form>
                    <Form.Label>{Strings['en'].short_course.modals.add_license.LICENSE_SELECT_LBL}</Form.Label>
                        <Form.Group controlId="mzl-cl-license-select">
                            <Form.Control
                                as="select"
                                onChange={(e) => this.onSelectLicense(e.target.value)}
                                disabled={!!this.state.addActionId || !!this.state.updateActionId || !!this.state.deleteActionId}
                            >
                                {licenseOptions.map((license) => {
                                    return (
                                        <option key={license.token} value={license.token}>{license.title}</option>
                                    );
                                })}
                            </Form.Control>
                        </Form.Group>
                        <Form.Group controlId="mzl-cl-token">
                            <Form.Label>{Strings['en'].short_course.modals.add_license.TOKEN_LBL}</Form.Label>
                            <Form.Control
                                type="text"
                                readOnly={this.state.selectedLicenseToken !== NEW_LICENSE_TOKEN}
                                disabled={this.state.selectedLicenseToken !== NEW_LICENSE_TOKEN}
                                value={this.state.token}
                                onChange={(e) => this.setState({ token: e.target.value })}
                            />
                        </Form.Group>
                        <Form.Row>
                            <Col>
                                <Form.Group controlId="mzl-cl-cost">
                                    <Form.Label>{Strings['en'].short_course.modals.add_license.COST_LBL}</Form.Label>
                                    <InputGroup>
                                        <InputGroup.Prepend>
                                            <InputGroup.Text className="font-size-14px">{StringUtil.formatUSD(this.state.cost)}</InputGroup.Text>
                                        </InputGroup.Prepend>
                                        <Form.Control
                                            type="number"
                                            min={0}
                                            value={this.state.cost}
                                            onChange={(e) => this.setState({ cost: e.target.value })}
                                        />
                                    </InputGroup>
                                </Form.Group>
                            </Col>
                            <Col>
                                <Form.Group controlId="mzl-cl-salecost">
                                    <Form.Label>{Strings['en'].short_course.modals.add_license.SALE_COST_LBL}</Form.Label>
                                    <InputGroup>
                                        <InputGroup.Prepend>
                                            <InputGroup.Text className="font-size-14px">{StringUtil.formatUSD(this.state.saleCost)}</InputGroup.Text>
                                        </InputGroup.Prepend>
                                        <Form.Control
                                            type="number"
                                            min={0}
                                            value={this.state.saleCost}
                                            onChange={(e) => this.setState({ saleCost: e.target.value })}
                                        />
                                    </InputGroup>
                                </Form.Group>
                            </Col>
                        </Form.Row>
                        <Form.Group controlId="mzl-cl-license-type">
                            <Form.Label>{Strings['en'].short_course.modals.add_license.LICENSE_TYPE_LBL}</Form.Label>
                            <Form.Control
                                as="select"
                                disabled={this.state.selectedLicenseToken !== NEW_LICENSE_TOKEN}
                                onChange={(e) => this.setState({ licenseTypeToken: e.target.value })}
                            >
                                <option
                                    value={Globals.ecommerce.course_license_types.INDIVIDUAL}
                                    selected={this.state.licenseTypeToken === Globals.ecommerce.course_license_types.INDIVIDUAL}
                                >
                                    {Strings['en'].short_course.license_types.INDIVIDUAL}
                                </option>
                                <option
                                    value={Globals.ecommerce.course_license_types.INSTITUTION}
                                    selected={this.state.licenseTypeToken === Globals.ecommerce.course_license_types.INSTITUTION}
                                >
                                    {Strings['en'].short_course.license_types.INSTITUTION}
                                </option>
                            </Form.Control>
                        </Form.Group>

                        {(this.state.licenseTypeToken === Globals.ecommerce.course_license_types.INDIVIDUAL) &&
                            <Form.Group controlId="mzl-cl-join-course-instance-hash">
                                <Form.Label>{Strings['en'].short_course.modals.add_license.JOIN_COURSE_INSTANCE_HASH_LBL}</Form.Label>
                                <Form.Control
                                    type="text"
                                    value={this.state.joinCourseInstanceHash}
                                    onChange={(e) => this.setState({ joinCourseInstanceHash: e.target.value })}
                                />
                            </Form.Group>
                        }
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    {(this.state.selectedLicenseToken !== NEW_LICENSE_TOKEN) &&
                        <Button
                            className="margin-right-lg"
                            variant="danger"
                            onClick={this.onDeleteLicense}
                            disabled={!!this.state.addActionId || !!this.state.updateActionId || !!this.state.deleteActionId}
                        >
                            {Strings['en'].common.DELETE_LC}
                        </Button>
                    }
                    <Button
                        onClick={this.onAddLicense}
                        disabled={!!this.state.addActionId || !!this.state.updateActionId || !!this.state.deleteActionId}
                    >
                        {(this.state.selectedLicenseToken === NEW_LICENSE_TOKEN) ?
                            Strings['en'].common.ADD
                            :
                            Strings['en'].common.UPDATE
                        }
                    </Button>
                </Modal.Footer>
            </Modal>
        );
    }
}

AddShortCourseLicenseModal.propTypes = propTypes;
AddShortCourseLicenseModal.defaultProps = defaultProps;

export default WithShortCourseLicenseData(AddShortCourseLicenseModal);